module.exports = __webpack_public_path__ + "img/1-2.742e19d8.png";